export default "__VITE_ASSET__B7ctKjz1__"